import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IEncounterData } from 'src/app/models/IEncounterData';
import { CQMSConfigurationService } from 'src/app/Services/CQMSConfiguration/cqmsconfiguration.service';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { MainCQMSDashBoardEMRMeasure, PatInfo } from 'src/app/models/CQMSDashBoardCalcDisplay';
import { MatTableDataSource } from '@angular/material';
import { DatePipe } from '@angular/common';
import { ProgressNotesService } from 'src/app/Services/NewVisitNote/progress-notes.service';
import { Defaults } from 'src/app/Utilities/defaults';
import { Router } from '@angular/router';
import { AESAlgorithm } from 'src/app/Utilities/Crypto/AESAlgorithm';
import { IAlerts } from 'src/app/models/IAlerts';
import { PopupAlertsComponent } from '../popup-alerts/popup-alerts.component';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { FormControl } from '@angular/forms';
export interface FailingPatData {
  patinfo: MainCQMSDashBoardEMRMeasure[];
  mesureName: string;
  measureId: number;
  PatName: string;
}
export interface PeriodicElement {
  date: string;
  providername: string;
  action: string;
}

@Component({
  selector: 'app-failing-encounter-dailog',
  templateUrl: './encounter-dailog.component.html',
  styleUrls: ['./encounter-dailog.component.css']
})
export class EncounterDailogComponent {
  displayedColumns: string[] = ['SLNO', 'VisitDate', 'ProviderName', 'CQMStatus', 'action'];
  filterValues = { VisitDate: '', ProviderName: '', PerformanceStatus: '' };
  patientInfo: MainCQMSDashBoardEMRMeasure[] = null;
  measureName: string = "";
  patName: string = "";
  measureId: number;
  constructor(private pastencountersService: ProgressNotesService,
    private sharedService: SharedService,
    public dialog: MatDialog,
    private router: Router,
    private crypto: AESAlgorithm,
    public dialogRef: MatDialogRef<EncounterDailogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: FailingPatData, private cqmsConfigurationService: CQMSConfigurationService) {
    this.patientInfo = this.data.patinfo;
    this.patName = this.data.PatName;
    this.measureName = this.patientInfo.filter(item => item.MeasureId = this.data.measureId)[0].MeasureName;
    this.measureId = this.data.measureId;
    this.getCQMSFailingEncounterPatients();

  }
  VisitDateFilter = new FormControl('');
  ProviderNameFilter = new FormControl('');
  PerformanceStatusFilter = new FormControl('');

  onCancelClick(): void {
    this.dialogRef.close();
    this.clearfiltervalues()
  }
  ngOnInit() {

    this.VisitDateFilter.valueChanges
      .subscribe(
        VisitDateFilters => {
          this.filterValues.VisitDate = VisitDateFilters;
          this.failingEncounterDataSource.filter = JSON.stringify(this.filterValues);

        }
      )
    this.ProviderNameFilter.valueChanges
      .subscribe(
        ProviderNameFilters => {
          this.filterValues.ProviderName = ProviderNameFilters;
          this.failingEncounterDataSource.filter = JSON.stringify(this.filterValues);

        }
      )

    this.PerformanceStatusFilter.valueChanges
      .subscribe(
        PerformanceStatusFilters => {
          this.filterValues.PerformanceStatus = PerformanceStatusFilters;
          this.failingEncounterDataSource.filter = JSON.stringify(this.filterValues);

        }
      )

  }

  clearfiltervalues() {
    this.VisitDateFilter.setValue("");
    this.ProviderNameFilter.setValue("");
    this.PerformanceStatusFilter.setValue("");

  }

  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = function (data, filter): boolean {

      let searchTerms = JSON.parse(filter);
      return (data.VisitDate === null || "" ? "" : data.VisitDate).toString().toLowerCase().indexOf(searchTerms.VisitDate.toLowerCase()) !== -1
        && (data.ProviderName === null || "" ? "" : data.ProviderName).toString().toLowerCase().indexOf(searchTerms.ProviderName.toLowerCase()) !== -1
        && (data.CQMStatus === null || "" ? "" : data.CQMStatus).toString().toLowerCase().indexOf(searchTerms.PerformanceStatus.toLowerCase()) !== -1

    }
    return filterFunction;
  }
  CQMSDashFilingList: MainCQMSDashBoardEMRMeasure[] = [];
  failingEncounterDataSource = new MatTableDataSource<MainCQMSDashBoardEMRMeasure>(this.CQMSDashFilingList);
  getCQMSFailingEncounterPatients() {
    //this.cqmsConfigurationService.GetCQMSFailingEncountersByPatientsId(this.patientInfo.patId, this.measureId).subscribe(
    // data => {
    this.CQMSDashFilingList = this.data.patinfo;
    this.failingEncounterDataSource.data = this.CQMSDashFilingList;
    this.failingEncounterDataSource.filterPredicate = this.createFilter();
    //    });
  }

  onCQMSVistEdit(element: any) {
    sessionStorage.setItem("displayappDate", this.transform(element.VisitDate.toString()));
    sessionStorage.setItem("displayappDate1", this.transform(element.VisitDate.toString()));
    this.dialogRef.close(element);
  }

  transform(value: string): string {
    if (value && value != undefined) {
      var datePipe = new DatePipe("en-US");
      value = datePipe.transform(value, 'MM/dd/yyyy');
    }
    return value;
  }
  private datePipe: DatePipe;
  dataSource = new MatTableDataSource();
  getPastEncounters(patid: number, encid: string) {

    this.pastencountersService.getPastEncounters(patid, 0, '').subscribe(
      (pastEncounters: IEncounterData[]) => {

        pastEncounters.forEach(element => {

          if (element.signedByDate != null) {
            //  var datetime = this.datePipe.transform(element.signedByDate, 'dd/MM/yyyy hh:mm');
            var datetime = this.datePipe.transform(element.signedByDate, 'MM/dd/yyyy hh:mm a');
            element.signedDate = datetime;
          }
        });
        this.dataSource.data = pastEncounters

      });

  }


  Navigate(ele: any) {
    sessionStorage.setItem("displayappDate", ele.dateVisit);
    sessionStorage.setItem("displayappDate1", ele.dateVisit);
    sessionStorage.setItem("pastnotedatetrue", "true");

    if (sessionStorage.getItem("displayappDate1") != null || sessionStorage.getItem("displayappDate1") != undefined) {
      sessionStorage.getItem("displayappDate1");
      sessionStorage.getItem("pastnotedatetrue");
    }
    if (localStorage.getItem("ordernoteheaderVisibility") != null)
      localStorage.removeItem("ordernoteheaderVisibility");
    if (sessionStorage.getItem("postFollowupVisibility") != null)
      sessionStorage.removeItem("postFollowupVisibility");
    this.displayPopupAlertsinClinic(this.patientInfo.filter(item => item.MeasureId = this.data.measureId)[0].PatId, ele.dateVisit)
    if (ele && ele != undefined) {
      if (ele.pumpStatus == Defaults.pumpStatus_Active)
        sessionStorage.setItem("pumPRefillVisibility", "True");
      else {
        if (sessionStorage.getItem("pumPRefillVisibility") != null)
          sessionStorage.removeItem("pumPRefillVisibility");
      }
      if (ele.encounterType == Defaults.enc_VisitNoteType)
        this.router.navigateByUrl('/Visitnote?encounterId=' + encodeURIComponent(this.crypto.urlParmeterEncoder(ele.encounterId)));
      else if (ele.encounterType == Defaults.enc_ORNoteType) {
        if (ele.encounterStatus == Defaults.appStatus_Completed)
          sessionStorage.setItem("postFollowupVisibility", "True");

        this.router.navigateByUrl('/ORNote?encounterId=' + encodeURIComponent(this.crypto.urlParmeterEncoder(ele.encounterId)));
      }
      else if (ele.encounterType = Defaults.enc_OrderNoteType) {
        sessionStorage.removeItem("rxfromsearch");
        sessionStorage.setItem("encounterid", ele.encounterId);
        localStorage.setItem("ordernoteheaderVisibility", "True");
        CommonComponents.headerVisibility = false;
        CommonComponents.ordernoteheaderVisibility = true;
        this.router.navigateByUrl('/OrderNote?id=' + encodeURIComponent(this.crypto.urlParmeterEncoder(sessionStorage.getItem("encounterid"))));
      }
    }

  }
  public lstPopUpAlerts: IAlerts[];
  public PopUpAlerts: IAlerts[] = [];
  public lstalerts: IAlerts[];
  rolealert: string = "";
  role: string = "";
  displayPopupAlertsinClinic(patId: number, visitDate: any) {

    if (patId > 0) {

      this.sharedService.lstPopUpAlerts = null;
      this.sharedService.getAlertsInfo(patId, visitDate)
        .subscribe(
          (data: any) => {
            this.lstPopUpAlerts = data;
            this.sharedService.lstPopUpAlerts = this.lstPopUpAlerts;
            if (this.sharedService.lstPopUpAlerts != null && this.sharedService.lstPopUpAlerts.length > 0) {
              var alertcount = this.sharedService.lstPopUpAlerts.filter((attr: IAlerts) => attr.isClinical == true && attr.isDismiss == true);
              alertcount = alertcount.filter((attr: IAlerts) => !attr.rolesName || attr.rolesName.includes(sessionStorage.getItem("role")));
              if (alertcount != null && alertcount.length > 0) {
                this.PopUpAlerts = alertcount;
                this.rolealert = "";
                this.PopUpAlerts.forEach(element => {
                  if (element.rolesName != null && element.rolesName != "") {
                    this.rolealert += element.rolesName + ',';
                  }
                });
                if (this.rolealert != null && this.rolealert != undefined && this.rolealert != "") {
                  if (this.rolealert.includes(sessionStorage.getItem("role"))) {
                    this.openAlertsPopup();
                  }
                } else {
                  this.openAlertsPopup();
                }
              }
            }
          },
          (err: any) => console.log(err)
        );
    }
  }
  openAlertsPopup(): void {
    const dialogRef = this.dialog.open(PopupAlertsComponent, {
      width: '1000px',
      height: '500px',
      data: this.PopUpAlerts

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result != undefined)

        { }

    });
  }

}
